// ═══════════════════════════════════════════════════════════════════════════
// COTISATIONS PATRONALES SPÉCIALES PAR CODE DmfA — une seule écriture
// ---------------------------------------------------------------------------
// Extrait le 07/10/2026 de app/api/onss/dmfa/route.js (calcul inchangé) pour
// que le COÛT EMPLOYEUR de la fiche lise les mêmes cotisations que la DmfA.
//
// Avant : la DmfA déclarait 6 codes (255, 256, 809, 810, 831, 859 ≈ 0,80 % pour
// une CP 200 de moins de 20 travailleurs) ; le coût employeur de la fiche n'en
// ajoutait qu'un, `cotSpecialeFFE` à 0,17 %, marqué « PÉRIMÉ 2026 » dans
// lois-belges.js. Deux montants pour la même cotisation (R14 bis).
//
// Les taux et leurs sources vivent dans LB.onss.cotisationsDmfa (R1) ; ce
// module n'applique que leurs CONDITIONS : trimestre (256 amiante), CP (831),
// effectif (809 : taux ≥ 20 travailleurs).
// ═══════════════════════════════════════════════════════════════════════════
import { LOIS_BELGES } from './lois-belges';

const r2 = (n) => Math.round(n * 100) / 100;

/**
 * Codes applicables et montants, sur une base donnée (mensuelle ou trimestrielle).
 * @param {{ base:number, cpNum:number, year:number, quarter:number, effectif?:number, codes?:Array }} o
 * @returns {{ codes: Array<{code:string, taux:number, amount:number}>, total:number, tauxTotal:number }}
 */
export function cotisationsSpecialesParCode({ base, cpNum, year, quarter, effectif = 0, codes }) {
  const liste = codes || (LOIS_BELGES.onss.cotisationsDmfa || {}).codes || [];
  const lignes = liste
    .filter((k) => !k.trimestresDus2026 || year !== 2026 || k.trimestresDus2026.includes(quarter))
    .filter((k) => !k.cpUniquement || k.cpUniquement.includes(cpNum))
    .map((k) => {
      const taux = (effectif >= 20 && k.tauxDes20Travailleurs) ? k.tauxDes20Travailleurs : k.taux;
      return { code: k.code, taux, amount: r2((Number(base) || 0) * taux) };
    })
    .filter((k) => k.amount > 0);
  const total = r2(lignes.reduce((a, k) => a + k.amount, 0));
  const tauxTotal = Math.round(lignes.reduce((a, k) => a + k.taux, 0) * 1e6) / 1e6;
  return { codes: lignes, total, tauxTotal };
}
